// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gauge_halfContainer__LA\\+GE {
    height: 100%;
    position: relative;
    margin: 0 30px;
}

.gauge_container__813Dx {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 130px;
    border-radius: 6px;
    position: relative;
    top: 35px;
}

.gauge_gaugeContainer__shKOe {
    width: 130px;
    height: 130px;
    background-color: #D9D9D9;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    transform: rotateZ(-90deg);
}

.gauge_gauge__LJGQs {
    width: 112px;
    height: 112px;
    border-radius: 50%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: conic-gradient(
            white 0deg 180deg,
            transparent 180deg 360deg
    );
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.gauge_gaugeValue__hQ3ce {
    text-align: center;
    transform: rotateZ(90deg);
    margin-left: 30px;
    font-size: 32px;
    display: flex;
    font-weight: 600;
    justify-content: center;
    align-items: end;
    color: #192949;
    font-family: Poppins;
}

.gauge_gaugeLabel__cmThF {
    text-align: center;
    width: 50px;
    transform: rotateZ(90deg);
    position: absolute;
    left: 20px;
    color: #C1C1C1;
    font-size: 11px;
    font-weight: 600;
}

.gauge_leftBall__48zjt {
    width: 9px;
    height: 9px;
    background: conic-gradient(
            transparent 0deg 90deg,
            #284480 90deg 270deg,
            transparent 270deg 360deg
    );
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: calc(50% - 5px);
    z-index: 10000;
}

.gauge_rightBall__5PUN7 {
    width: 9px;
    height: 9px;
    background: conic-gradient(
            transparent 0deg 90deg,
            #D9D9D9 90deg 270deg,
            transparent 270deg 360deg
    );
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: calc(50% - 5px);
    z-index: 10000;
}`, "",{"version":3,"sources":["webpack://./src/screens/detail/components/gauge/gauge.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC;;;KAGC;IACD,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX;;;;KAIC;IACD,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX;;;;KAIC;IACD,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,cAAc;AAClB","sourcesContent":[".halfContainer {\n    height: 100%;\n    position: relative;\n    margin: 0 30px;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 130px;\n    border-radius: 6px;\n    position: relative;\n    top: 35px;\n}\n\n.gaugeContainer {\n    width: 130px;\n    height: 130px;\n    background-color: #D9D9D9;\n    border-radius: 50%;\n    overflow: hidden;\n    position: relative;\n    transform: rotateZ(-90deg);\n}\n\n.gauge {\n    width: 112px;\n    height: 112px;\n    border-radius: 50%;\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: conic-gradient(\n            white 0deg 180deg,\n            transparent 180deg 360deg\n    );\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.gaugeValue {\n    text-align: center;\n    transform: rotateZ(90deg);\n    margin-left: 30px;\n    font-size: 32px;\n    display: flex;\n    font-weight: 600;\n    justify-content: center;\n    align-items: end;\n    color: #192949;\n    font-family: Poppins;\n}\n\n.gaugeLabel {\n    text-align: center;\n    width: 50px;\n    transform: rotateZ(90deg);\n    position: absolute;\n    left: 20px;\n    color: #C1C1C1;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.leftBall {\n    width: 9px;\n    height: 9px;\n    background: conic-gradient(\n            transparent 0deg 90deg,\n            #284480 90deg 270deg,\n            transparent 270deg 360deg\n    );\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    top: calc(50% - 5px);\n    z-index: 10000;\n}\n\n.rightBall {\n    width: 9px;\n    height: 9px;\n    background: conic-gradient(\n            transparent 0deg 90deg,\n            #D9D9D9 90deg 270deg,\n            transparent 270deg 360deg\n    );\n    border-radius: 50%;\n    position: absolute;\n    right: 0;\n    top: calc(50% - 5px);\n    z-index: 10000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"halfContainer": `gauge_halfContainer__LA+GE`,
	"container": `gauge_container__813Dx`,
	"gaugeContainer": `gauge_gaugeContainer__shKOe`,
	"gauge": `gauge_gauge__LJGQs`,
	"gaugeValue": `gauge_gaugeValue__hQ3ce`,
	"gaugeLabel": `gauge_gaugeLabel__cmThF`,
	"leftBall": `gauge_leftBall__48zjt`,
	"rightBall": `gauge_rightBall__5PUN7`
};
export default ___CSS_LOADER_EXPORT___;
